import React from 'react';

import GuessCorrectnessBanner from '../ContentBlocks/GuessCorrectnessBanner';
import type {GuessStatus} from '../ContentBlocks/GuessCorrectnessBanner';

import AdjustedTotalIndicator from './AdjustedTotalIndicator.react';

type Props = {
  /** The grade's total in rubric points: the teacher's own total when set, else the criteria sum. */
  earned: number;
  max: number;
  /** The total disagrees with the criterion scores below it; see `isTotalAdjusted`. */
  isAdjusted: boolean;
};

/**
 * The correctness banner over a released FRQ grade. Shared by the student's view and the
 * teacher's preview of it, so both report the same grade and the same adjusted-total note.
 */
export default function ReleasedGradeBanner({earned, max, isAdjusted}: Props) {
  const status: GuessStatus =
    max > 0 && earned >= max ? 'correct' : earned === 0 ? 'incorrect' : 'partiallyCorrect';

  return (
    <GuessCorrectnessBanner
      partialCreditEnabled
      overriddenGuessStatus={status}
      overriddenGrade={max > 0 ? earned / max : 0}
      className='mb-x0!'
      trailing={
        isAdjusted ? (
          <AdjustedTotalIndicator
            placement='bottom-end'
            message='Your teacher adjusted your total score, so it won’t add up to the rubric scores below. Those scores still show how you did on each criterion.'
          />
        ) : null
      }
    />
  );
}
